import { render, staticRenderFns } from "./RatingsPage.vue?vue&type=template&id=6b8d6aa6&scoped=true"
import script from "./RatingsPage.vue?vue&type=script&lang=js"
export * from "./RatingsPage.vue?vue&type=script&lang=js"
import style0 from "./RatingsPage.vue?vue&type=style&index=0&id=6b8d6aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8d6aa6",
  null
  
)

export default component.exports